import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { SYS_ADMIN } from 'config/permissions/roles';
import administrationsComponent from './admins-by-category-pie.component';
import adminsByCategoryService from './admins-by-category-pie.service';

export default
  angular.module('components.reports.administrationsByCategoryPie', [
    uiRouter
  ])
    .component('administrationsByCategoryPie', administrationsComponent)
    .service('AdminsByCategoryPieService', adminsByCategoryService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('administrationsByCategoryPie', {
          parent: 'reports',
          url: '/administrations-by-category-pie',
          component: 'administrationsByCategoryPie',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-pie/admins-by-category-pie.module.js